import * as Sentry from '@sentry/react';

export const initSentry = system => {
  if (!system) {
    return;
  }

  Sentry.init({
    dsn: 'https://a9f032472d8ffd7dc685750045302254@o24149.ingest.us.sentry.io/4510045147627520',
    // Set to false to avoid conflict with GDPR
    sendDefaultPii: false,
    environment: `${system}_${
      window.location.hostname === 'localhost' ? 'dev' : process.env.HOST_NAME
    }`,
  });
};
